// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-core-Dropzone-_ziLAf","dragAndDropGraphic":"styles-module__dragAndDropGraphic__src-labstep-web-core-Dropzone-_VB9EE"};